var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
const initialState = {
    data: [],
    count: 0,
    loading: false,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchPostsByThread = createAsyncThunk('reduxPosts/fetchByThread', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ threadId, params }, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.threads.posts({ id: threadId }, Object.assign({ ordering: '-postedOn' }, params.queries), params.headers);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const fetchPreviousPosts = createAsyncThunk('reduxPosts/fetchPreviousPosts', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ threadId, before, params }, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.threads.posts({ id: threadId }, Object.assign({ ordering: '-postedOn', postedOn__lte: before, page_size: 50 }, params.queries), params.headers);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const updatePost = createAsyncThunk('reduxPosts/update', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ postId, text, headers }, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = api.posts.update({
            id: postId,
            text,
        }, null, headers);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const createPost = createAsyncThunk('reduxPosts/create', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ threadId, text, headers }, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.posts.create({
            thread: threadId,
            text,
        }, null, headers);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxPosts',
    initialState,
    reducers: {
        addPostFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
        updatePostFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = state.data.map((post) => {
                if (post.id === updatedPayload.id) {
                    return Object.assign(Object.assign({}, post), updatedPayload);
                }
                return post;
            });
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // FETCH POSTS BY THREAD
        builder.addCase(fetchPostsByThread.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchPostsByThread.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload.results];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
            state.loading = false;
        });
        builder.addCase(fetchPostsByThread.rejected, (state) => {
            state.loading = false;
        });
        // FETCH PREVIOUS POSTS
        builder.addCase(fetchPreviousPosts.pending, (state) => {
            // state.loading = true
        });
        builder.addCase(fetchPreviousPosts.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload.results];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
            state.loading = false;
        });
        builder.addCase(fetchPreviousPosts.rejected, (state) => {
            state.loading = false;
        });
    },
});
export const { addPostFromWS, updatePostFromWS } = actions;
export default reducer;
